import { actionConst } from '../constants/add-orgs.constants'
import { authHeader, authUploadHeader, authHeaderForm } from '../helpers/auth-header'
import { client } from '.';
import { documentsActions } from '../containers/Documents/store/actions/documents.actions';
import { tuple } from 'antd/lib/_util/type';
import { fromDateStr } from '../helpers/utcDate';

const actions = {
	openModal,
	closeModal,
	addDocumentOrgs,
};

async function addOrg(org,docId) {
	const rurl = '/docs/addOrgToDoc/'+docId
	const result = await client.post(rurl, org, { headers: authHeader() })	
}

function addDocumentOrgs(value) {
	return dispatch => {
		new Promise((resolve, reject) => {
			value.keys.forEach(async e =>  {
			if(e || e === 0) {
				const o = {
					Id: null,
					OrgId: value.orgId && value.orgId[e] && parseInt(value.orgId[e]),
					InNumber: value.InNumber && value.InNumber[e] ? value.InNumber[e] : null,
					InDate: value.InMoment && value.InMoment[e] ? fromDateStr(value.InMoment[e]) : null, 
				}
				const result = await addOrg(o,value.docId)
			}})
			resolve() 
		}).then(() => {
				dispatch(documentsActions.fetchDocuments());			
		})
	}
}
	
function openModal(v) {
	return dispatch => {
				dispatch({
					type: actionConst.OPEN_MODAL,
					payload: v
				})		
	}
}

function closeModal() {
	return dispatch => {
		dispatch({
			type: actionConst.CLOSE_MODAL
		})
	}
}

export default actions